/**
 * Created by Mark on 18/04/2017.
 */


import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Row , Col , ProgressBar , Button } from 'react-bootstrap';
import ClassService from '../../../services/classes-service.js';
import LanguageSelector from '../../inputs/language-selector.js';
import Toggle from '../../inputs/input.toggle.component.js';
import AssignmentServices from '../../../services/assignment-services.js';
import { Link , hashHistory } from "react-router";

class ReviewStudents extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = { saved: true};
    }

    componentDidMount() {

        AssignmentServices.publish(this.props.data.homeworkID).then(function(){
            hashHistory.push('/assignment/managment')
        });
    }

    renderSaving(){
        return <div><Row><Col sm={4} smOffset={4} ><center><h4><FormattedMessage id="5025" defaultMessage="Saving Your Class"/></h4></center></Col></Row><Row><Col sm={2} smOffset={5} >
            <div className="preloader pl-xl pls-blue">
                <svg className="pl-circular" viewBox="25 25 50 50">
                    <circle className="plc-path" cx="50" cy="50" r="20"/>
                </svg>
            </div>
        </Col></Row></div>
    }

    renderSaved(){


        return <div></div>
    }

    render(){
        if(this.state.saved) return this.renderSaved()
        else return this.renderSaving();
    }
}


export default {
    name: <FormattedMessage id={ 'ui-336' } defaultMessage={ 'Save' }/>,
    onSubmit: function (done){
        done();
    },
    component: ReviewStudents
}


// WEBPACK FOOTER //
// ./src/components/wizard/homework-steps/save-assignment.js